import { createIcon } from '@chakra-ui/react';

export const ResetIcon = createIcon({
  displayName: 'ResetIcon',
  viewBox: '0 0 18 18',
  defaultProps: {
    fill: 'none',
    height: '18',
    width: '18',
  },
  path: (
    <>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M9 0.25C13.8325 0.25 17.75 4.16751 17.75 9C17.75 13.8325 13.8325 17.75 9 17.75C5.49026 17.75 2.46432 15.6834 1.07031 12.7041L1.75 12.3867L2.42969 12.0684C3.58619 14.54 6.09401 16.25 9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99594 13.0041 1.75 9 1.75C6.36946 1.75 4.06496 3.15102 2.79395 5.25L5 5.25098H5.75V6.75H2C1.03368 6.74983 0.250058 5.96634 0.25 5V1.25H1.75V4.10059C3.32257 1.77831 5.98215 0.25 9 0.25Z"
          fill="#334E68"
        />
      </svg>
    </>
  ),
});
